import fetch from 'fetch-retry'
import { observable, computed, action, toJS } from 'mobx'
import { fromPromise } from 'mobx-utils'
import { asyncComputed } from 'computed-async-mobx'
import Promise from 'bluebird'
import qs from 'qs'
import _get from 'lodash/get'
import _mapValues from 'lodash/mapValues'

import moment from 'moment'
import catchmentStationsQuery from '~/graphql/queries/catchmentStations.gql'
import stationResponseDataQuery from '~/graphql/queries/stationResponseData.gql'
// import stationForcingDataQuery from '~/graphql/queries/stationForcingData.gql'
import stationsSalinityDataQuery from '~/graphql/queries/stationsSalinityData.gql'
import forcingDataByTypesQuery from '~/graphql/queries/forcingDataByTypes.gql'
import poisQuery from '~/graphql/queries/pois.gql'
import scenarioQuery from '~/graphql/queries/scenario.gql'
import config from '~/config'
import apolloClient from '../apollo-client'
import viewStore from '~/stores/view'
import userStore from '~/stores/user'
// import user from '~/user.json'
// import userPoiStore from '~/stores/userPoi'

const SALINITY_ID = _get(config, 'app.parameters', []).find(p => p.name === 'ความเค็ม').id

class DataStore {
  // @observable responseData = fromPromise.resolve({})

  @observable forcingData = fromPromise.resolve({})
  @observable mainStationId = null
  @observable stations = []
  @observable pois = []
  @observable selectedScenarios = []
  // @observable station
  @computed get now () {
    return _get(config, ['now', viewStore.mode], moment().format('YYYY-MM-DD HH:mm:ss'))
  }
  @action
  fetchCatchmentStations (catchmentId) {
    // TODO: if scenario query from scenarioids
    apolloClient.query({
      query: catchmentStationsQuery,
      variables: {
        catchmentId
      }
    }).then(action(({ data }) => {
      this.mainStationId = _get(data, 'catchment.mainStationId')
      this.stations = _get(data, 'catchment.stations.nodes')
    }))
  }

  @action
  fetchPois (userId) {
    // TODO: if scenario query from scenarioids
    apolloClient.query({
      query: poisQuery,
      variables: {
        userId
      }
    }).then(action(({ data }) => {
      this.pois = _get(data, 'pois.nodes')
    }))
  }

  @action
  addPoi (poi) {
    const pois = this.pois.concat(poi)
    this.pois.replace(pois)
  }

  @action
  removePoi (poiId) {
    const pois = this.pois.filter(p => p.id !== parseInt(poiId, 10))
    this.pois.replace(pois)
  }

  @action
  fetchScenarios () {
    Promise.map(viewStore.scenarioIds, scenarioId =>
      apolloClient.query({
        query: scenarioQuery,
        variables: {
          id: scenarioId
        }
      }).then(({ data }) => {
        return _get(data, 'scenario')
      })
    ).then(scenarios => {
      this.selectedScenarios = scenarios
    })

    // Promise.map(this.scen)
    // apolloClient.query({
    //   query: scenariosQ
    // })
  }

  salinityOverlayData = asyncComputed(null, 300, () => {
    const { mode } = viewStore
    if (mode === 'scenario') {
      const baseUri = process.env.REACT_APP_SCENARIO_RESPONSE_URI
      const offset = (Math.abs(viewStore.daysOffset) || 0)
      const scenarioId = viewStore.scenarioIds[0]
      if (scenarioId) {
        return fetch(`${baseUri}/${userStore.profile.email}/${scenarioId}/day${parseFloat(offset).toFixed(1)}_salt.json`, {
          cache: 'no-cache',
          retries: 3,
          retryDelay: 300
        }).then(res => {
          if (res.ok) {
            return res.json()
          } else {
            throw new Error(res.statusText)
          }
        })
      }
    } else {
      const baseUri = process.env.REACT_APP_OVERLAY_DATA_URI
      const offset = (Math.abs(viewStore.daysOffset) || 0)
      // TODO: if scenario use scenario uri
      return fetch(`${baseUri}/day${parseFloat(offset).toFixed(1)}_salt.json`, {
        cache: 'no-cache',
        retries: 3,
        retryDelay: 300
      }).then(res => res.json())
    }
  })

  // poiSalinityData = asyncComputed({}, 100, () => {
  //   const { mode } = viewStore
  //   if (userPoiStore.items.length > 0) {
  //     const dataTypeId = _get(config, ['app', mode, 'dataTypeId'])
  //     if (mode === 'forecasting') {
  //       const baseUri = process.env.REACT_APP_FORECAST_RESPONSE_URI
  //       return Promise.map(userPoiStore.items, poi => (
  //         fetch(
  //           `${baseUri}?${qs.stringify({
  //             latitude: poi.position.lat,
  //             longitude: poi.position.lng,
  //             data_type_id: SALINITY_ID
  //           })}`, {
  //             retries: 3,
  //             retryDelay: 300
  //           }
  //         ).then(res => {
  //           if (res.ok) {
  //             return res.json()
  //           } else {
  //             throw new Error(res.statusText)
  //           }
  //         }).then(({ data }) =>
  //           data.map(d => ({
  //             value: d.value,
  //             observedTimestamp: d.timestamp,
  //             type: {
  //               id: SALINITY_ID,
  //               name: _get(config, 'app.parameters', []).find(p => p.id === dataTypeId).name
  //             }
  //           }))
  //         ).catch(err => {
  //           console.error(err)
  //           return []
  //         })
  //       ), {
  //         concurrency: 1
  //       }).then(poisData => {
  //         return poisData.reduce((result, poiData, index) => ({
  //           ...result,
  //           [userPoiStore.items[index].id]: poiData
  //         }), {})
  //       })
  //     } else {
  //       return Promise.resolve({})
  //     }
  //     // return Promise.props(responseData$)
  //   }
  // })

  salinityData = asyncComputed({}, 300, () => {
    const { mode } = viewStore
    if (this.stations.length > 0) {
      const { startDate, endDate } = ({
        monitoring: {
          startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).add({ days: 1 }).format('YYYY-MM-DD HH:mm:ss')
        },
        forecasting: {
          // startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          startDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).add({ days: 7 }).format('YYYY-MM-DD HH:mm:ss')
        }
      })[mode]
      const dataTypeId = _get(config, ['app', mode, 'dataTypeId'])
      if (mode === 'forecasting') {
        const baseUri = process.env.REACT_APP_FORECAST_RESPONSE_URI
        const stations = this.stations.map(s => ({ ...s, id: `s${s.id}` }))
        const pois = this.pois.map(p => ({ ...p, id: `p${p.id}` }))
        const stationsPois = stations.concat(pois)
        return Promise.map(stationsPois, station => (
          Promise.delay(
            300,
            fetch(
              `${baseUri}?${qs.stringify({
                latitude: station.latitude,
                longitude: station.longitude,
                data_type_id: SALINITY_ID
              })}`, {
                cache: 'no-cache',
                retries: 3,
                retryDelay: 300
              }
            ).then(res => {
              if (res.ok) {
                return res.json()
              } else {
                throw new Error(res.statusText)
              }
            }).then(({ data }) =>
              data.map(d => ({
                value: d.value,
                observedTimestamp: d.timestamp,
                type: {
                  id: SALINITY_ID,
                  name: _get(config, 'app.parameters', []).find(p => p.id === dataTypeId).name
                }
              }))
            ).catch(err => {
              console.error(err)
              return []
            })
          )
        ), {
          concurrency: 1
        }).then(stationsData => {
          return stationsData.reduce((result, stationData, index) => ({
            ...result,
            [stationsPois[index].id]: stationData
          }), {})
        })
      } else if (mode === 'monitoring') {
        return apolloClient.query({
          query: stationsSalinityDataQuery,
          variables: {
            catchmentId: viewStore.catchmentId,
            dataTypeId,
            salinityId: SALINITY_ID,
            startDate,
            endDate
          }
        }).then(({ data }) => {
          const stations = _get(data, 'catchment.stations.nodes', [])
          return stations.reduce((result, station) => ({
            ...result,
            [station.id]: _get(station, 'salinityData.nodes')
          }), {})
        }).catch(console.error)
      }
      // return Promise.props(responseData$)
    }
  })

  scenariosSalinityData = asyncComputed({}, 300, () => {
    const baseUri = process.env.REACT_APP_SCENARIO_RESPONSE_URI
    const scenariosMap = this.selectedScenarios.reduce((map, scenario) => {
      map[scenario.id] = scenario
      return map
    }, {})
    // console.log({ baseUri })
    const scenarioData$ = _mapValues(scenariosMap, scenario => {
      // console.log({ scenario })
      const stationsPois = _get(scenario, 'outputs.nodes', [])
        // .filter(sp =>
        //   sp.isPoi
        //     ? viewStore.poiIds.includes(sp.stationPoiId)
        //     : viewStore.stationIds.includes(sp.stationPoiId)
        // )
        .map(sp => ({ ...sp, spId: sp.isPoi ? `p${sp.stationPoiId}` : `s${sp.stationPoiId}` }))
      // console.log({ stationsPois })
      return Promise.map(stationsPois, sp => {
        const fileName = sp.isPoi ? `poi_${sp.stationPoiId}.json` : `station_${sp.stationPoiId}.json`
        return Promise.delay(
          300,
          fetch(
            `${baseUri}/${userStore.profile.email}/${scenario.id}/${fileName}`, {
              cache: 'no-cache',
              retries: 3,
              retryDelay: 300
            }
          ).then(res => {
            if (res.ok) {
              return res.json()
            } else {
              throw new Error(res.statusText)
            }
          }).then(({ data }) =>
            data.map(d => ({
              value: d.value,
              observedTimestamp: d.timestamp,
              type: {
                id: SALINITY_ID,
                name: _get(config, 'app.parameters', []).find(p => p.id === SALINITY_ID).name
              }
            }))
          ).catch(err => {
            console.error(err)
            return []
          })
        )
      }, {
        concurrency: 1
      }).then(stationsData => {
        return stationsData.reduce((result, stationData, index) => ({
          ...result,
          [stationsPois[index].spId]: stationData
        }), {})
        // console.log({ stationsData })
        // return []
        // return stationsData.reduce((result, stationData, index) => ({
        //   ...result,
        //   [stationsPois[index].id]: stationData
        // }), {})
      })
    })
    return Promise.props(scenarioData$)
  })

  scenariosFlocData = asyncComputed({}, 300, () => {
    const baseUri = process.env.REACT_APP_SCENARIO_RESPONSE_URI
    const scenariosMap = this.selectedScenarios.reduce((map, scenario) => {
      map[scenario.id] = scenario
      return map
    }, {})
    // console.log({ baseUri })
    const scenarioData$ = _mapValues(scenariosMap, scenario => {
      // console.log({ scenario })
      // const stationsPois = _get(scenario, 'outputs.nodes', [])
      const flocs = _get(scenario, 'settings.nodes', [])
        .map(setting => setting.forcingLocation)
        .filter(floc =>
          viewStore.flocIds.includes(floc.id)
        )
      return Promise.map(flocs, floc => {
        const fileName = `floc_${floc.id}.json`
        return Promise.delay(
          300,
          fetch(
            `${baseUri}/${userStore.profile.email}/${scenario.id}/${fileName}`, {
              cache: 'no-cache',
              retries: 3,
              retryDelay: 300
            }
          ).then(res => {
            if (res.ok) {
              return res.json()
            } else {
              throw new Error(res.statusText)
            }
          }).then(({ data }) =>
            data.map(d => ({
              value: d.value,
              observedTimestamp: d.timestamp
              // type: {
              //   id: SALINITY_ID,
              //   name: _get(config, 'app.parameters', []).find(p => p.id === SALINITY_ID).name
              // }
            }))
          ).catch(err => {
            console.error(err)
            return []
          })
        )
      }, {
        concurrency: 1
      }).then(flocsData => {
        return flocsData.reduce((result, flocData, index) => ({
          ...result,
          [flocs[index].id]: flocData
        }), {})
      })
    })
    return Promise.props(scenarioData$)
  })

  forcingData = asyncComputed(null, 300, () => {
    const { mode, dataTypeIds: { forcing } } = viewStore
    const forcingDataTypes = toJS(forcing)
    // console.log({ forcingDataTypes })
    if (forcingDataTypes) {
      const { startDate, endDate } = ({
        monitoring: {
          startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss')
        },
        forecasting: {
          // startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          startDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).add({ days: 7 }).format('YYYY-MM-DD HH:mm:ss')
        }
        // scenario: {
        //   // startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
        //   startDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss'),
        //   endDate: moment(this.now).add({ days: 7 }).format('YYYY-MM-DD HH:mm:ss')
        // }
      })[mode]
      const dataTypeId = _get(config, ['app', mode, 'dataTypeId'])
      const forcingData$ = _mapValues(forcingDataTypes, (typeIds, cat) =>
        apolloClient.query({
          query: forcingDataByTypesQuery,
          variables: {
            dataTypeId,
            typeIds,
            startDate,
            endDate
          }
        }).then(({ data }) => _get(data, 'forcingData.nodes', [])).catch(err => {
          console.error(err)
          return []
        })
      )
      return Promise.props(forcingData$)
    }
  })

  scenarioForcingData = asyncComputed(null, 300, () => {
    const { mode } = viewStore
    // const { mode, dataTypeIds: { forcing } } = viewStore
    // const forcingDataTypes = toJS(forcing)
    // console.log({ forcingDataTypes })
    const dataTypeId = _get(config, ['app', mode, 'dataTypeId'])
    const typeIds = _get(config, ['app', mode, 'typeIds'], [])
    const { startDate, endDate } = ({
      startDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(this.now).add({ days: 7 }).format('YYYY-MM-DD HH:mm:ss')
    })
    return apolloClient.query({
      query: forcingDataByTypesQuery,
      variables: {
        dataTypeId,
        typeIds,
        startDate,
        endDate
      }
    }).then(({ data }) => _get(data, 'forcingData.nodes', [])).catch(err => {
      console.error(err)
      return []
    })
  })

  responseData = asyncComputed({}, 300, () => {
    const { mode, stationIds, poiIds, dataTypeIds: { response } } = viewStore
    const responseDataTypes = toJS(response)
    const sIds = stationIds || []
    const pIds = poiIds || []
    const ids = sIds.concat(pIds)
    if (ids.length && responseDataTypes) {
      const { startDate, endDate } = ({
        monitoring: {
          startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).add({ days: 1 }).format('YYYY-MM-DD HH:mm:ss')
        },
        forecasting: {
          // startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          startDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).add({ days: 7 }).format('YYYY-MM-DD HH:mm:ss')
        },
        scenario: {
          // startDate: moment(this.now).subtract({ days: 7 }).format('YYYY-MM-DD HH:mm:ss'),
          startDate: moment(this.now).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(this.now).add({ days: 7 }).format('YYYY-MM-DD HH:mm:ss')
        }
      })[mode]
      const dataTypeId = _get(config, ['app', mode, 'dataTypeId']) // monitoring / forecast
      const stations = this.stations.filter(s => stationIds.includes(s.id))
      const pois = this.pois.filter(p => poiIds.includes(p.id))
      // console.log(this.stations)
      const stationsMap = stations.reduce((map, station) => {
        map[`s${station.id}`] = station
        return map
      }, {})
      const poisMap = pois.reduce((map, poi) => {
        map[`p${poi.id}`] = poi
        return map
      }, {})
      const stationPoisMap = Object.assign({}, stationsMap, poisMap)

      let responseData$ = {}
      if (mode === 'forecasting') {
        if (ids.length) {
          const baseUri = process.env.REACT_APP_FORECAST_RESPONSE_URI
          responseData$ = _mapValues(responseDataTypes, (typeIds, cat) =>
            Promise.props(
              _mapValues(stationPoisMap, (sp, spId) =>
                Promise.map(typeIds, typeId => (
                  Promise.delay(
                    300,
                    fetch(
                      `${baseUri}?${qs.stringify({
                        latitude: sp.latitude,
                        longitude: sp.longitude,
                        data_type_id: typeId
                      })}`, {
                        cache: 'no-cache',
                        retries: 3,
                        retryDelay: 300
                      }
                    ).then(res => {
                      if (res.ok) {
                        return res.json()
                      } else {
                        // throw new Error(res.statusText)
                        console.error(res.statusText)
                        return { data: [] }
                      }
                    }).then(({ data }) =>
                      data.map(d => ({
                        value: d.value,
                        observedTimestamp: d.timestamp,
                        type: {
                          id: typeId,
                          name: _get(config, 'app.parameters', []).find(p => p.id === typeId).name
                        }
                      }))
                    ).catch(err => {
                      console.error(err)
                      return []
                    })
                  )
                ), {
                  concurrency: 1
                })
              ), {
                concurrency: 1
              }
            )
          )
        }
      } else if (mode === 'monitoring') {
        // const [ stationId ] = stationIds
        responseData$ = _mapValues(responseDataTypes, (typeIds, cat) =>
          Promise.props(
            _mapValues(stationsMap, (station, stationId) =>
              Promise.map(stations, station =>
                apolloClient.query({
                  query: stationResponseDataQuery,
                  variables: {
                    stationId: station.id,
                    dataTypeId, // monitoring / forecast
                    typeIds,
                    startDate,
                    endDate
                  }
                }).then(({ data }) => _get(data, 'station.responseData.nodes', [])
                ).catch(err => {
                  console.error(err)
                  return []
                })
              )
            )
          )
        )
      }
      return Promise.props(responseData$).catch(err => console.error(err))
    }
  })
}

const dataStore = new DataStore()

export default dataStore



// WEBPACK FOOTER //
// ./src/stores/data.js